Model = require('./model')

class CallDispositionCollection extends Backbone.Collection
  model: Model
  url: 'callDispositions'

module.exports = CallDispositionCollection